import { render, staticRenderFns } from "./quest-disconnected.vue?vue&type=template&id=7480e366"
import script from "./quest-disconnected.vue?vue&type=script&lang=js"
export * from "./quest-disconnected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports